import { render, staticRenderFns } from "./appMenu.vue?vue&type=template&id=0b55890a"
import script from "./appMenu.vue?vue&type=script&lang=js"
export * from "./appMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports